module.exports = __webpack_public_path__ + "static/media/instagram-green.5b5e3626.png";